import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { BulkArchiveBundleDialog } from '@/features/admin/bundle/BulkArchiveBundleDialog'
import { type BulkArchiveBundleDialogViewModel } from './BulkArchiveBundleDialogViewModel'

export interface BulkArchiveBundleDialogContainerProps {
  vm: BulkArchiveBundleDialogViewModel
}

export const BulkArchiveBundleDialogContainer = observer(
  function BulkArchiveBundleDialogContainer({
    vm,
  }: BulkArchiveBundleDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <BulkArchiveBundleDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onArchive={vm.archive}
        isArchivePending={vm.archive.pending}
        count={vm.archivableBundles.length}
        corporateMode={shellInfo.corporateMode}
        testId="bulk-archive"
      />
    )
  },
)
